var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',{staticClass:"mt-4",attrs:{"row":"","fluid":"","fill-height":"","justify-center":"","column":_vm.column}},[_vm._t("title"),_vm._t("loader",function(){return [_c('VProgressCircular',{attrs:{"indeterminate":"","color":"primary"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }